import React, { useEffect, useState, useContext } from 'react';
import get from 'lodash/get';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import AddIcon from '@wix/da-ds/pkg/Icons/16x16/Add';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import CollectionsList from '../../../CollectionPanel/CollectionList';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DSModal, { MODAL_FOOTER_BUTTON_SIZE } from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import DSPopover, { POPOVER_FOOTER_BUTTON_SIZE } from '@wix/da-ds/pkg/popovers/dsPresets/Popover';
import NewCollectionPopup from './NewCollectionPopup';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import s from './AddToCollectionPopup.scss';
const AddToCollectionPopup = ({ collectibleDeviation , collectibleDeviation: { deviationId  } , className , isInitialized , hasMoreCollections , collectionsCount , ignorePreselectedCollections , notificationQueue , selectedFolderIds , initializeCollectionsForDeviation , commitCollections , removeQueues , onClose  })=>{
    const { t  } = useTranslation();
    useEffect(()=>{
        if (!isInitialized) {
            const noPreselectedFeatured = true;
            initializeCollectionsForDeviation(deviationId, get(collectibleDeviation, 'stats.favourites', 0), noPreselectedFeatured, ignorePreselectedCollections);
        }
    }, [
        isInitialized,
        initializeCollectionsForDeviation,
        deviationId,
        collectibleDeviation,
        ignorePreselectedCollections
    ]);
    // flush everything from a given (via props) notificationQueue on init
    // so that on save the new notification doesn't overlap with any old ones
    useEffect(()=>{
        removeQueues((name)=>name === notificationQueue);
    }, [
        notificationQueue,
        removeQueues
    ]);
    const isMobile = useContext(MobileContext);
    const [filterValue, setFilterValue] = useState('');
    const [showingNewCollectionPopup, setShowNewCollectionPopup] = useState(false);
    const onFilterInputChange = (e)=>setFilterValue(e.target.value);
    const onDone = ()=>{
        commitCollections(collectibleDeviation, notificationQueue || 'default');
        onClose();
    };
    if (showingNewCollectionPopup) {
        return /*#__PURE__*/ React.createElement(NewCollectionPopup, {
            className: className,
            collectibleDeviation: collectibleDeviation,
            onClose: ()=>setShowNewCollectionPopup(false)
        });
    }
    const { author  } = collectibleDeviation;
    const filterInput = !hasMoreCollections && collectionsCount >= 5 ? /*#__PURE__*/ React.createElement(TextInput, {
        id: "search-input",
        className: s['filter-input'],
        biData: BiData({
            evid: 2,
            click_info: 'addToCollectionPopover.filterInput',
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue
        }),
        label: t('addToCollectionPopover.input.filter.placeholder'),
        placeholder: t('addToCollectionPopover.input.filter.placeholder'),
        value: filterValue,
        onChange: onFilterInputChange,
        prefix: /*#__PURE__*/ React.createElement(SearchIcon, {
            disableDefaultColors: true
        }),
        noBottomSpacing: true,
        isLabelHidden: true
    }) : undefined;
    const doneButton = /*#__PURE__*/ React.createElement(SolidButton, {
        variant: "approval-green",
        biData: {
            evid: BiEventType.ADD_TO_COLLECTION_DONE_CLICK,
            creatorid: author && author.useridUuid,
            typeid: getDeviationResourceType(collectibleDeviation),
            itemid: deviationId,
            sectionname: undefined,
            collectionid: selectedFolderIds.length > 1 ? undefined : selectedFolderIds[0],
            num_collections: selectedFolderIds.length
        },
        onClick: onDone,
        size: isMobile ? MODAL_FOOTER_BUTTON_SIZE : POPOVER_FOOTER_BUTTON_SIZE
    }, t('common.done'));
    const newCollectionButton = /*#__PURE__*/ React.createElement(TextButton, {
        onClick: ()=>setShowNewCollectionPopup(true),
        icon: AddIcon,
        size: "small",
        variant: "main",
        biData: BiData({
            evid: 2,
            click_info: 'addToCollectionPopover.newCollection',
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue
        })
    }, t('addToCollectionPopover.button.newCollection'));
    if (isMobile) {
        return /*#__PURE__*/ React.createElement(DSModal, {
            isOpen: true,
            heading: t('addToCollectionPopover.title'),
            className: className,
            contentClassName: s['content-wrapper'],
            showHeaderBorder: true,
            showFooterBorder: true,
            footerRight: [
                doneButton
            ],
            footerLeft: [
                newCollectionButton
            ],
            withScrollableContentWrapper: false,
            onRequestClose: onClose
        }, filterInput, /*#__PURE__*/ React.createElement(CollectionsList, {
            collectibleDeviation: collectibleDeviation,
            filterValue: filterValue
        }));
    }
    return /*#__PURE__*/ React.createElement(DSPopover, {
        heading: t('addToCollectionPopover.title'),
        className: c(s['popover-root'], className),
        contentClassName: s['content-wrapper'],
        showFooterBorder: true,
        footerRight: doneButton,
        footerLeft: newCollectionButton,
        onCloseClick: onClose,
        content: /*#__PURE__*/ React.createElement(React.Fragment, null, filterInput, /*#__PURE__*/ React.createElement(CollectionsList, {
            collectibleDeviation: collectibleDeviation,
            filterValue: filterValue
        }))
    });
};
AddToCollectionPopup.displayName = 'AddToCollectionPopup';
export default AddToCollectionPopup;
